import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function TickIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M5 15l4 4L19 6"
  }));
}
export function TickIconSmall(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M5 10l3 3 5-8"
  }));
}